"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withOpacity = exports.pxToRem = exports.createSideMargins = exports.createShadow = void 0;
var lodash_1 = require("lodash");
/**
 * Create shadow
 *
 * @param {number} [offsetX=0] - Shadow X axis offset
 * @param {number} [offsetY=0] - Shadow Y axis offset
 * @param {number} [blurRadius=0] - Shadow blur radius
 * @param {number} [opacity=0] - Shadow color opacity value in range (0, 1)
 * @param {spread} [spread=false] - Optional spread of the shadow
 * @example
 * createShadow(0, 1, 1, 0.5)
 * // returns '0px 1px 1px 0 rgba(0, 0, 0, 0.5)'
 * @returns {string}
 */
var createShadow = function (offsetX, offsetY, blurRadius, opacity, spread) {
    if (offsetX === void 0) { offsetX = 0; }
    if (offsetY === void 0) { offsetY = 0; }
    if (blurRadius === void 0) { blurRadius = 0; }
    if (opacity === void 0) { opacity = 0; }
    return "".concat(offsetX, "px ").concat(offsetY, "px ").concat(blurRadius, "px").concat(spread ? ' 0' : '', " rgba(0, 0, 0, ").concat(opacity, ")");
};
exports.createShadow = createShadow;
/**
 * Create padding depending on number of columns and grid spacing
 *
 * @param {number} [columns=12] - Number of columns
 * @param {number} [skipColumns=0] - How many columns to skip
 * @param {number} [spaceBetweenGridColumns=0] - Spacing between columns adjuster
 * @returns {object}
 */
var createPadding = function (columns, skipColumns, spaceBetweenGridColumns) {
    if (columns === void 0) { columns = 12; }
    if (skipColumns === void 0) { skipColumns = 0; }
    if (spaceBetweenGridColumns === void 0) { spaceBetweenGridColumns = 0; }
    if (skipColumns) {
        return "calc(((100% / ".concat(columns, ") * ").concat(skipColumns, ") - ").concat(spaceBetweenGridColumns, "px)");
    }
    return undefined;
};
/**
 * Create side margins depending on number of columns, grid spacing and content side spacing
 *
 * @param {number} [columns=12] - Number of columns in grid
 * @param {number} [skipColumns=0] - How many columns to skip
 * @param {number} [innerContentSideSpacing=0] - Adjuster for inner content side spacing
 * @param {number} [spaceBetweenGridColumns=0] - Adjuster for spacing between grid columns
 * @param {number} [maxWidth=1264] - Container max width
 * @returns {object}
 */
var createSideMargins = function (columns, skipColumns, innerContentSideSpacing, spaceBetweenGridColumns, maxWidth) {
    if (columns === void 0) { columns = 12; }
    if (skipColumns === void 0) { skipColumns = 0; }
    if (innerContentSideSpacing === void 0) { innerContentSideSpacing = 0; }
    if (spaceBetweenGridColumns === void 0) { spaceBetweenGridColumns = 0; }
    if (maxWidth === void 0) { maxWidth = 1264; }
    return {
        marginLeft: 'auto',
        marginRight: 'auto',
        width: innerContentSideSpacing ? "calc(100% - ".concat(innerContentSideSpacing * 2, "px)") : '100%',
        paddingLeft: createPadding(columns, skipColumns, spaceBetweenGridColumns),
        paddingRight: createPadding(columns, skipColumns),
        maxWidth: maxWidth,
    };
};
exports.createSideMargins = createSideMargins;
/**
 * Round input `value` to number of decimal `places`
 *
 * @param {number} [value]
 * @param {number} [places=5]
 * @example round(1/3, 5) returns 0.33333
 * @returns {number}
 * @description Rounds calculations to specified decimal places to avoid long numbers.
 */
var round = function (value, places) {
    if (places === void 0) { places = 5; }
    return Math.round(value * Math.pow(10, places)) / Math.pow(10, places);
};
/**
 * Convert pixels to rem using root font size
 *
 * @param {number} [size]
 * @param {number} [rootFontSize=16]
 * @example pxToRem(20) returns '1.25rem'
 * @example pxToRem(20, 12) returns '1.66666rem'
 * @returns {string}
 */
/**
 * We use the `round` function to avoid cases where calculations can return long results.
 * For example if we try to convert 20px to rem with root font size of 12px we would get a value of 1.66666666667,
 * but with the `round` function set to 5 decimal places we get `1.66666`.
 */
var pxToRem = function (size, rootFontSize) {
    if (rootFontSize === void 0) { rootFontSize = 16; }
    return "".concat(round(size / rootFontSize, 5), "rem");
};
exports.pxToRem = pxToRem;
/**
 * Adds opacity to existing hex color
 *
 * @param {string} color Color in HEX
 * @param {number} opacity Value of opacity in range (0, 1)
 * @example withOpacity('#E5E5E5', 0.7) returns #E5E5E5B3
 * @returns {string}
 */
var withOpacity = function (color, opacity) {
    if ((color.length !== 4 && color.length !== 7) || !color.startsWith('#')) {
        throw new Error('Color must be hex format');
    }
    // Check if color is written in short hand, i.e: #FCO is equal to #FFCC00
    if (color.length === 4) {
        var _a = __read(color.slice(1).split(''), 3), red = _a[0], green = _a[1], blue = _a[2];
        color = "#".concat(red).concat(red).concat(green).concat(green).concat(blue).concat(blue);
    }
    // Cast the opacity into Hex representation
    var opacityAsHex = Math.round(opacity * 255).toString(16);
    return "".concat(color).concat((0, lodash_1.padStart)(opacityAsHex, 2, '0'));
};
exports.withOpacity = withOpacity;
